import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICoverageAreaInput } from "@/interfaces/coverage-area.interface";
import coverageAreaService from "@/services/coverage-area.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateCoverageAreaProps = UpdateByIdProps<ICoverageAreaInput>;

export type UseUpdateCoverageAreaReturn = {
  update: (props: UpdateCoverageAreaProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateCoverageArea = (): UseUpdateCoverageAreaReturn => {
  const reponse = useUpdate<ICoverageAreaInput>({
    operation: (formData, coverageAreaId) => coverageAreaService.update(formData, coverageAreaId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, update } = reponse;

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdateCoverageArea;
